export default __webpack_public_path__ + "67b595b52b7fd6ec6c940e53ffe28ce6.svg";